import { NavLink } from 'react-router-dom';
import './Sidebar.scss'
import { FaChevronRight } from 'react-icons/fa'
import { useEffect, useState } from 'react';
const Sidebar = () => {

    const [isOpen, setIsOpen] = useState(true);
    let sidebar = document.querySelector('#id--sidebar');

    function toggleSidebar() {
        sidebar.classList.toggle('show');
        console.log('Im entering');
    }

    useEffect(() => {
        sidebar = document.querySelector('#id--sidebar');
    }, [])

    return (
        <>
            <div className="sidebar--style bottom-0 d-none d-md-block">
                <ul className=''>
                    <li className=''>
                        <NavLink to="/" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Inicio</NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-2" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> ¿Qu&eacute; es un beb&eacute; prematuro?</NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-3" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Riesgos: respiraci&oacute;n</NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-4" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Riesgos: infecciones</NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-5" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Bronquiolitis y s&iacute;ntomas</NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-6" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Bronquiolitis y signos de alarma</NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-7" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Prevenci&oacute;n de VSR y virus respiratorios</NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-8" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> En el hospital
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-9" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> En casa: higiene y ambiente
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-10" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> En casa: visitas y m&eacute;todo canguro
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-11" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Alimentaci&oacute;n para beb&eacute;s prematuros
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-12" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Posiciones para sacar gases
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-13" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Dulces sue&ntilde;os
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-14" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> C&oacute;mo asear a mi beb&eacute; prematuro
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lesson-15" exact className='text--item--sidebar py-2 padding--li w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Disfrute al m&aacute;ximo el tiempo con su beb&eacute;
                        </NavLink>
                    </li>
                </ul>
            </div>

            <div id="id--sidebar" className="sidebar--style bottom-0 offcanvas" tabindex="-1">
                <div className='offcanvas-body p-0'>
                    <ul className='p-0'>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Inicio</NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-2" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> ¿Qu&eacute; es un beb&eacute; prematuro?</NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-3" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Riesgos: respiraci&oacute;n</NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-4" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Riesgos: infecciones</NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-5" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Bronquiolitis y s&iacute;ntomas</NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-6" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Bronquiolitis y signos de alarma</NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-7" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Prevenci&oacute;n de VSR y virus respiratorios</NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-8" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> En el hospital
                            </NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-9" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> En casa: higiene y ambiente
                            </NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-10" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> En casa: visitas y m&eacute;todo canguro
                            </NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-11" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Alimentaci&oacute;n para beb&eacute;s prematuros
                            </NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-12" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Posiciones para sacar gases
                            </NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-13" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Dulces sue&ntilde;os
                            </NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-14" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> C&oacute;mo asear a mi beb&eacute; prematuro
                            </NavLink>
                        </li>
                        <li onClick={toggleSidebar}>
                            <NavLink to="/lesson-15" exact className='text--item--sidebar py-2 px-2 w-100 d-inline-block' activeClassName='active'> <FaChevronRight className='me-3 ms-5' /> Disfrute al m&aacute;ximo el tiempo con su beb&eacute;
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Sidebar;